export default function publicHeader(){
    return { Authorization: `Basic ${btoa("PublicUser:acc84ffd-76b2-4477-9365-71fa83b16129")}`};
}